import { PiQuestion, PiShield, PiShieldWarning } from 'react-icons/pi';
import { IconType } from 'react-icons';

export const severityToIcon = (
  severity: string | undefined
): React.ElementType => {
  let IconComponent: IconType | React.FC<React.SVGProps<SVGSVGElement>>;

  switch (severity) {
    case 'note':
      IconComponent = PiShield;
      break;
    case 'warning':
      IconComponent = PiShieldWarning;
      break;
    case 'alert':
      IconComponent = PiShieldWarning;
      break;
    default:
      IconComponent = PiQuestion;
  }

  return IconComponent;
};
